<template>
  <div class="tab-pane fade" id="sum-content" role="tabpanel" aria-labelledby="sum-content-tab">
    <div class="container-fluid">
      <form class="row g-3">
        <div class="col-md-4">
          <label for="inputEmail4" class="form-label">遊客中心</label>
          <select class="form-control" v-model.number="selectScenicAreaId">
            <option value="-1">全部</option>
            <option v-for="(list, index) in peopleAnalysisScenicArea" :key="index" :value="list.id">{{list.name}}</option>
          </select>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料開始時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="startTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-4">
          <label for="inputPassword4" class="form-label">資料結束時間</label>
          <datetime input-class="form-control" type="datetime" format="yyyy-MM-dd HH:mm"
            :phrases="{ ok: '確認', cancel: '取消' }" :minute-step="1" :max-datetime="maxSelectTime" :auto="true"
            v-model="endTime" @focus="updateMaxSelectTime">
          </datetime>
        </div>

        <div class="col-md-6 d-flex align-items-end">
          <button type="button" class="btn btn-success bg-cyan btn-sm rounded-pill px-3 mx-1" @click="queryElk" :disabled="isWaitCCTVList">
            <i class="fas fa-search"></i> 查詢
          </button>
          <button type="button" class="btn btn-primary btn-sm rounded-pill px-3 mx-1" @click="queryCSV" :disabled="isWaitCCTVList"> 
            <i class="fas fa-share"></i> 匯出
          </button>
        </div>
      </form>

      <h1 style="margin-top: 0px;">統計 （日）</h1>

      <div class="row row-cols-1 row-cols-md-1 row-cols-lg-2 row-cols-flex g-2">
        <div class="col order-2 order-md-1">
          <div class="card card-clean h-100">
            <div class="bd-example">

              <table id="sumCenterPeople" class=" w3-table-all table table-hover table-striped">
                <thead class="table-dark ">
                  <tr>
                    <th scope="col" width="5%">#</th>
                    <th scope="col">時間</th>
                    <th scope="col">遊客中心</th>
                    <th scope="col">在園人數</th>
                    <th scope="col">進場人數</th>
                    <th scope="col">離場人數</th>                    
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in peopleCountDataList" :key="index" :class="tableCenterStyle">
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.time }}</td>
                    <td>{{ item.areaName}}</td>
                    <td>{{ item.peopleStay }}</td>
                    <td>{{ item.peopleIn}}</td>
                    <td>{{ item.peopleOut }}</td>
                  </tr>
                  <!-- <tr v-if="peopleCountDataList.length > 0" :class="tableCenterStyle">
                    <td>{{ peopleCountDataList.length + 1 }}</td>
                    <td>{{ totalData.name }}</td> -->
                    <!-- <td>{{ totalData.scenicName}}</td> -->
                    <!-- <td>{{ totalData.peopleStay }}</td>
                    <td>{{ totalData.peopleIn }}</td>
                    <td>{{ totalData.peopleOut }}</td> -->
                  <!-- </tr> -->
                </tbody>
              </table>

            </div>
          </div>
        </div>

        <div class="col order-1  order-md-2 pt-md-4">
          <div id="sumCenterPeopleChart">
                      <apexchart
                        type="area"
                        height="200"
                        :options="sumPeopleFlowSetting"
                        :series="sumPeopleFlowData"
                      ></apexchart>
          </div>
        </div>
      </div>

    </div>
  </div>
    

  
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import Utils from '../../utils/utils';
import CONST from '../../utils/const'
import exportCSV from '../../utils/exportCSV'
import { postCentralPeopleFlow } from '../../api/eastCoastDataApi/ElkQuery/PeopleFlowElk'
import ApexchartObject from '../../utils/apexchartObject/centerPeopleFlow'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      tableStyle: "table table-bordered table-hover h6",
      tableThStyle: "bg-info text-white text-center",
      tableCenterStyle: "text-center",
      startTime: moment().startOf('day').format(),
      endTime: moment().startOf('minute').format(),
      selectScenicAreaId: -1,
      peopleCountDataList: [],
      // totalData: {},
      isWaitCCTVList: false,
      sumPeopleFlowData:[],
      sumPeopleFlowSetting: ApexchartObject.sumPeopleFlow,
      maxSelectTime: moment().startOf('m').toISOString(),

    };
  },
  watch: {
    async selectScenicAreaId() {
      // this.isWaitCCTVList = true
      // await this.$store.dispatch('scenicArea/getDeviceByScenicAreaId', { id: this.selectScenicAreaId })
      // this.selectDeviceId = "-1"
      // this.isWaitCCTVList = false
    },
  },
  computed: {
    // maxSelectTime() {
    //   return moment()
    //     .startOf('m')
    //     .toISOString()
    // },
    // ...mapState('scenicArea', {scenicAreaList: 'allscenicArea'}),
    ...mapGetters("scenicArea", { scenicAreaList: "getMyScenicArea" }),


     peopleAnalysisScenicArea() {
      console.log()
      return this.scenicAreaList.filter(s => (s.additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PEOPLE_ANALYZE))
    },

    searchAreaName() {
      const area = this.scenicAreaList.find(s => s.id === this.selectScenicAreaId)
      return area ? area.name : ''
    },

    searchTime() {
      return `${moment(this.startTime).format('YYYY/MM/DD HH:mm')}~${moment(this.endTime).format('YYYY/MM/DD HH:mm')}`
    },
  },
  methods: {
    getTableAreaName(name) {
      if(Utils.isEmptyObject(name))
        return this.searchAreaName

      return name  
    },
    updateMaxSelectTime() {
      this.maxSelectTime = Utils.getLastestTime();// 更新為當前時間
    },

    async queryCSV() {
      const peopleCountDataList = await this.searchELK()
      if(Utils.isEmptyObject(peopleCountDataList)) {
        alert('沒有資料')
        return
      }

      const csvContent = [['時間', '遊客中心', '在園人數', '進場人數', '離場人數']]
      peopleCountDataList.forEach(item => {
        const row = []
        row.push(item.time)
        row.push(item.areaName)
        row.push(item.peopleStay)
        row.push(item.peopleIn)
        row.push(item.peopleOut)

        csvContent.push(row)
      })

      const fileName = `CSV_${moment(this.startTime).format('YYYY/MM/DD HH:mm')}_遊客人數統計(日).csv`
      exportCSV.genCSVFile(csvContent, fileName)
    },

    async queryElk () {
      this.peopleCountDataList = await this.searchELK()
      this.setChartData(this.peopleCountDataList)
      this.updateTable()
    },

    async searchELK() {
      if (Utils.isEmptyObject(this.startTime) || Utils.isEmptyObject(this.endTime)) {
        alert('請選擇起訖時間')
        return
      }

      const condition = {
        areas:[],
        sttime: moment(this.startTime).startOf('minute').format(),
        endtime: moment(this.endTime).startOf('minute').format(),
        interval: "day"
      }


      if(this.selectScenicAreaId === -1) {
        //全選
        this.peopleAnalysisScenicArea.forEach(e => {
          condition.areas.push(e.id)
        })
      }

      if(this.selectScenicAreaId > -1) {
        condition.areas.push(this.selectScenicAreaId)
      }

      const result = await postCentralPeopleFlow(condition)
      if(!result.success){
        return []
      }

      const total = {
        time: '統計',
        areaName: '',
        peopleIn: 0,
        peopleOut: 0,
        peopleStay: 0
      }

      const dataList = result.data.map(e => {
        const data ={}
        data.areaName = e.areaName
        data.areaId = e.areaId
        data.time = `${moment(e.dateTime).format('YYYY-MM-DD')}`
        data.peopleIn = e.peopleIn
        data.peopleOut = e.peopleOut
        data.peopleStay = e.peopleStay
        data.dateTime = e.dateTime

        total.peopleIn = total.peopleIn + data.peopleIn
        total.peopleOut = total.peopleOut + data.peopleOut

        return data
      })

      total.peopleStay = total.peopleIn - total.peopleOut < 0? 0 : total.peopleIn - total.peopleOut

      dataList.push(total)
      return dataList
    },
    
    setChartData(dataList) {
      
  
      console.log("dataList",dataList)
      const list = dataList.slice(0, -1); //移除最後一個統計元素，產生新陣列
      let vm = this;
      let areaShowArray =list
        .map((item) => {
          return item.areaName;
        })
        .filter((item, index, self) => {
          return self.indexOf(item) === index;
        });


        let dateShowArray =list
        .map((item) => {
          return item.time;
        })
        .filter((item, index, self) => {
          return self.indexOf(item) === index;
        });
        // console.log("dateShowArray",dateShowArray);

        let seriesData = areaShowArray.map((currentArea, indexArea) => {
        //取得每個area的數據
        let result = {};
        result.name = currentArea;
        let areaData = list
          .filter((item) => item.areaName == currentArea)
          .map((item) => item.peopleIn);

          result.data = areaData;
          return result;
        });

        // console.log("seriesData",seriesData); 
        this.sumPeopleFlowData = seriesData; 
      //
      // const sumList = Object.values(list.reduce((acc, obj) => {
      //   //將相同天數的人數相加
      //   if (acc[obj.time]) {
      //     acc[obj.time].peopleStay += obj.peopleStay;
      //     acc[obj.time].peopleIn += obj.peopleIn;
      //     acc[obj.time].peopleOut += obj.peopleOut;
      //   } else {
      //     acc[obj.time] = { ...obj };
      //   }
      //   return acc;
      // }, {}));

      // this.sumPeopleFlowData = []
      // const peopleStayCount = sumList.map((d, i) => {
      //   return d.peopleStay
      // })

      // const peopleInCount = sumList.map((d, i) => {
      //   return d.peopleIn
      // })

      // const peopleOutCount = sumList.map((d, i) => {
      //   return d.peopleOut
      // })

      // this.sumPeopleFlowData.push({name: '在園人數', data: peopleStayCount})
      // this.sumPeopleFlowData.push({name: '進場人數', data: peopleInCount})
      // this.sumPeopleFlowData.push({name: '離場人數', data: peopleOutCount})   

      let chartSetting = {...this.sumPeopleFlowSetting};
      
      
      let xaxisCategories = dateShowArray.map((d, i) => {
        const month = moment(d).format("MM");
        const date = moment(d).format("DD");
        const category = `${month}-${date}`;
        return category
      })
      
      // chartSetting.xaxis.categories = xaxisCategories;
      // console.log("xax",xaxisCategories);

      if(xaxisCategories.length === 1) {
        //若選擇開始/結束時間均為當天，則圖表時間軸顯示該天的0000~2400;
        console.log("當天")
        const data = Utils.setapexChartZeroDayType(xaxisCategories, this.sumPeopleFlowData)

        xaxisCategories = data.xaxisCategories;
        this.sumPeopleFlowData = data.chartData;
        let xaxisArray=[] ;
        
        xaxisArray[0] = moment(this.startTime).startOf("day").format("MM-DD HH");
        xaxisArray[1] = moment(xaxisCategories[0]).format("MM-DD");
        xaxisArray[2] = moment(this.endTime).add(1, "days").startOf("day").format("MM-DD HH");
        console.log("xaxisArray",xaxisArray);
        xaxisCategories = xaxisArray;
      }

      // console.log("xaxisCategories",xaxisCategories); 
    
      if(moment(this.endTime).format("YYYY-MM-DD") === moment().format("YYYY-MM-DD")) {
        //若搜尋年份開結束時間為今年份、則日期僅顯示到今天
        xaxisCategories[xaxisCategories.length-1] = moment().format("MM-DD HH");
      }

      

      chartSetting.xaxis.categories = xaxisCategories
      chartSetting.chart.toolbar.export={
              csv: {
                filename: `統計(日)_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              svg: {
                filename: `統計(日)_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              },
              png: {
                filename: `統計(日)_遊客中心人次_${moment().format("YYYY年MM月DD日_HH時mm分")}`,
              }
            }

      chartSetting.tooltip.y.formatter =  function (value, { series, seriesIndex, dataPointIndex, w }) {
            return  value + " 人";
          };
        
      this.sumPeopleFlowSetting = {...chartSetting} // 根據apexcharts官方文件，option與series需同時更新統計圖才會更新
    },

    initTable: function () {
      this.table = $("#sumCenterPeople").DataTable({
        aoColumns: [
          ...new Array($("#sumCenterPeople th").length - 1),
          {
            bSortable: false,
          },
        ],
        language: {
          url :'/json/dataTableZHTW.json'
        },
        "pageLength": 32,
      });
    },

    updateTable() {
      if(!Utils.isEmptyObject(this.table)){
        this.table.destroy()
      }
      
      setTimeout(() => {
        this.initTable();
      }, 100);
    }
  },
  mounted() {
    this.updateTable()
  }
};
</script>
<style>
button:disabled {
  cursor: not-allowed;
  pointer-events: all !important;
}
tbody > tr > td, tr > th {width:100%;white-space:normal;word-wrap:break-word;word-break:break-all;} /* td自動斷行 */
table{table-layout:fixed;word-break:break-all;}  /* table不超過div */
</style>
